import { Fragment, useContext, useEffect, useState } from 'react'
import {
  clearFilterHistory,
  filterStorageKey,
  getFilterHistory,
} from 'features/dashboard/utils/storage/filterStorage'
import NoneAnchor from 'components/NoneAnchor'
import FilterName from 'features/dashboard/filter/FilterName'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import { batch, useDispatch } from 'react-redux'
import { setFilters } from 'features/dashboard/filter/dashboardFilterSlice'
import Tooltip from 'components/tooltip/Tooltip'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const FilterHistories = () => {
  const dispatch = useDispatch()
  const { setMenuVisible } = useContext(FilterContext)
  const [histories, setHistories] = useState(getFilterHistory())
  useEffect(() => {
    const storageEventHandler = event => {
      if (event.key === filterStorageKey) {
        setHistories(getFilterHistory())
      }
    }
    window.addEventListener('storage', storageEventHandler)
    return () => {
      window.removeEventListener('storage', storageEventHandler)
    }
  }, [])
  return (
    <>
      <ul className="list_lyadsearch">
        {histories.length > 0 ? (
          histories.map(({ id, filters }) => (
            <Tooltip
              key={id}
              nowrap={false}
              tag="li"
              display="block"
              position="right alignTop"
              content={filters.map(({ domain, key, data }) => (
                <p className="txt_tooltip" key={`${domain}_${key}_tooltip`}>
                  <FilterName domain={domain} type={key} data={data} />
                </p>
              ))}>
              <NoneAnchor
                className="link_searchfilter"
                onClick={() => {
                  setMenuVisible(false)
                  window.scrollTo({ top: 0 })
                  batch(() => {
                    dispatch(setFilters(filters))
                    dispatch(campaignTableActions.setPage(0))
                    dispatch(adGroupTableActions.setPage(0))
                    dispatch(keywordTableActions.setPage(0))
                    dispatch(creativeTableActions.setPage(0))
                  })
                }}>
                {filters.map(({ domain, key, data }, index, array) => (
                  <Fragment key={`${domain}_${key}`}>
                    <FilterName domain={domain} type={key} data={data} />
                    {index < array.length - 1 ? ', ' : ''}
                  </Fragment>
                ))}
              </NoneAnchor>
            </Tooltip>
          ))
        ) : (
          <li>
            <span className="link_searchfilter">최근 검색한 조건 없음</span>
          </li>
        )}
      </ul>
      {histories.length > 0 && (
        <ul className="list_lyadsearch">
          <li>
            <NoneAnchor
              className="link_searchfilter"
              onClick={() => {
                setMenuVisible(false)
                clearFilterHistory()
              }}>
              최근 검색 조건 모두삭제
            </NoneAnchor>
          </li>
        </ul>
      )}
    </>
  )
}
export default FilterHistories
